export default "__VITE_ASSET__DREHusjP__"